export default __webpack_public_path__ + "table-light.3dd54321.svg";